// extracted by mini-css-extract-plugin
export var audioPlayer = "_sh-0";